export interface EditableDirectDebit {
  type: 'DIRECT_DEBIT';
  id: number;
  accountOwner: string;
  iban: string;
  bank: string | null;
  bic: string | null;
}
